import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import Small from 'UIComponents/elements/Small';
import Big from 'UIComponents/elements/Big';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { getDisplayPercentage } from './utils/formattingUtils';
import { StyledProgressBar } from './StyledProgressBar';
import { EMPTY_VALUE } from '../../constants/constants';
import { AttainmentBarName } from './AttainmentBarName';

const defaultRenderValue = value => /*#__PURE__*/_jsx("div", {
  children: /*#__PURE__*/_jsx(FormattedNumber, {
    value: value
  })
});

const defaultRenderGoal = goal => /*#__PURE__*/_jsx("div", {
  children: goal ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "attainmentBar.goal",
    options: {
      value: goal
    }
  }) : EMPTY_VALUE
});

export const AttainmentBar = ({
  avatarSize = 'xs',
  email,
  goal,
  height = 10,
  isPercentageBig = false,
  name,
  onClickAttainmentBar,
  renderGoal = defaultRenderGoal,
  renderValue = defaultRenderValue,
  showAvatar = true,
  showClosedAmountSection = false,
  showPercentage = true,
  showSubtext = true,
  tooltipProps = {},
  value
}) => {
  const attainmentPercentage = goal ? value / goal * 100 : undefined;
  const hasAttainerInfo = name || email;
  const showPercentageInLine = !hasAttainerInfo && showPercentage;
  let percentage;

  if (showPercentage) {
    percentage = isPercentageBig ? /*#__PURE__*/_jsxs(Big, {
      children: [" ", getDisplayPercentage(attainmentPercentage)]
    }) : getDisplayPercentage(attainmentPercentage);
  }

  const attainmentBarHeight = showClosedAmountSection ? 5 : height;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasAttainerInfo && /*#__PURE__*/_jsxs(UIFlex, {
      style: {
        height: '40px'
      },
      className: "m-bottom-2",
      align: "center",
      justify: "between",
      "data-test-id": "attainer-info",
      children: [showAvatar ? /*#__PURE__*/_jsx(AttainmentBarName, {
        email: email,
        name: name,
        avatarSize: avatarSize
      }) : /*#__PURE__*/_jsx(UITruncateString, {
        children: /*#__PURE__*/_jsx("b", {
          children: name
        })
      }), showPercentage && /*#__PURE__*/_jsx(UIBox, {
        "data-test-id": "attainer-info-percentage",
        className: "m-left-2 text-right",
        basis: 10,
        grow: 1,
        children: percentage
      })]
    }), showClosedAmountSection && /*#__PURE__*/_jsx(UIFlex, {
      align: "end",
      justify: "end",
      "data-test-id": "closed-amount-section",
      children: renderValue(value)
    }), /*#__PURE__*/_jsxs(UIFlex, {
      className: "m-bottom-2",
      align: "center",
      justify: "between",
      children: [/*#__PURE__*/_jsx(UITooltip, Object.assign({
        disabled: tooltipProps && !tooltipProps.title
      }, tooltipProps, {
        children: /*#__PURE__*/_jsx(UIBox, {
          grow: 1,
          "data-test-id": "attainment-bar" //@ts-expect-error Not an explict prop
          ,
          onClick: onClickAttainmentBar,
          children: /*#__PURE__*/_jsx(StyledProgressBar, {
            attainmentPercentage: attainmentPercentage,
            height: attainmentBarHeight,
            handleClickAttainmentBar: onClickAttainmentBar
          })
        })
      })), showPercentageInLine && /*#__PURE__*/_jsx(UIBox, {
        "data-test-id": "inline-percentage",
        className: "m-left-2",
        grow: 0,
        children: percentage
      })]
    }), showSubtext && /*#__PURE__*/_jsxs(UIFlex, {
      "data-test-id": "attainment-bar-subtext",
      children: [/*#__PURE__*/_jsx(UIBox, {
        shrink: 0,
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          "data-test-id": "attainment-closed",
          children: renderValue(value)
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        grow: 1
      }), /*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx(Small, {
          "data-test-id": "attainment-goal",
          children: renderGoal(goal)
        })
      })]
    })]
  });
};